import React, { useEffect, useState, useRef } from "react";
import { getIcons } from "../Constant/Constant";
import { use } from "react";
import CallLogService from "../Services/CallLogService";
import { useNavigate } from "react-router-dom";
import { FaMicrophoneLines, FaPlay, FaPause, FaStop } from "react-icons/fa6";
import { FaVolumeUp } from "react-icons/fa";
import { getBasePathByUserRole } from "../../utils/roleRoutes";

const CallLog = ({ callLogHistory, toggle, selectedTab, setSelectedTab }) => {
  const icons = getIcons();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeRecordingId, setActiveRecordingId] = useState(null);
  const [playingStates, setPlayingStates] = useState({});
  const [currentTime, setCurrentTime] = useState({});
  const [duration, setDuration] = useState({});
  const audioRefs = useRef({});
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;

  const handleLeadInfo = (lead) => {
    let path = getBasePathByUserRole();
    navigate(`${path}/lead-info/${lead}`);
  };

  const filteredCallLogHistory = Array.isArray(callLogHistory)
    ? callLogHistory.filter((call) =>
        call.leadName.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const statusImage = {
    "Registered Client": icons.customerIcon,
    Fresh: icons.freshIcon,
    Dealing: icons.dealingIcon,
    "Deal Lost": icons.dealLostIcon,
    "Follow-up": icons.interestedIcon,
    "Retry Suitable": icons.RetrySuitable,
    "Not Interested": icons.notInterestedIcon,
     Unanswered: icons.unansweredIcon,
     "Junk" : icons.Junk,
  };

  const leadCharacter = {
    "Not Applicable": icons.NAEmoji,
    Excited: icons.excitedEmoji,
    Neutral: icons.neutralEmoji,
    Confused: icons.confusedEmoji,
    Thinking: icons.ThinkingEmoji,
    None: icons.NAEmoji,
  };

  const filteredCalls = filteredCallLogHistory.filter((item) =>
    item.leadName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // Audio control functions
  const toggleRecording = (callId, audioUrl) => {
    if (activeRecordingId === callId) {
      // Close the current recording
      if (audioRefs.current[callId]) {
        audioRefs.current[callId].pause();
        audioRefs.current[callId].currentTime = 0;
      }
      setActiveRecordingId(null);
      setPlayingStates((prev) => ({ ...prev, [callId]: false }));
    } else {
      // Close any other open recording first
      if (activeRecordingId && audioRefs.current[activeRecordingId]) {
        audioRefs.current[activeRecordingId].pause();
        audioRefs.current[activeRecordingId].currentTime = 0;
        setPlayingStates((prev) => ({ ...prev, [activeRecordingId]: false }));
      }
      // Open the new recording
      setActiveRecordingId(callId);
    }
  };

  const togglePlayPause = (callId) => {
    const audio = audioRefs.current[callId];
    if (!audio) return;

    if (playingStates[callId]) {
      audio.pause();
      setPlayingStates((prev) => ({ ...prev, [callId]: false }));
    } else {
      audio.play().catch((error) => {
        console.error("Error playing audio:", error);
      });
      setPlayingStates((prev) => ({ ...prev, [callId]: true }));
    }
  };

  const stopAudio = (callId) => {
    const audio = audioRefs.current[callId];
    if (!audio) return;

    audio.pause();
    audio.currentTime = 0;
    setPlayingStates((prev) => ({ ...prev, [callId]: false }));
    setCurrentTime((prev) => ({ ...prev, [callId]: 0 }));
  };

  const handleTimeUpdate = (callId) => {
    const audio = audioRefs.current[callId];
    if (audio) {
      setCurrentTime((prev) => ({ ...prev, [callId]: audio.currentTime }));
    }
  };

  const handleLoadedMetadata = (callId) => {
    const audio = audioRefs.current[callId];
    if (audio) {
      setDuration((prev) => ({ ...prev, [callId]: audio.duration }));
    }
  };

  const handleEnded = (callId) => {
    setPlayingStates((prev) => ({ ...prev, [callId]: false }));
    setCurrentTime((prev) => ({ ...prev, [callId]: 0 }));
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(1, "0")}`;
  };

  const handleSeek = (callId, value) => {
    const audio = audioRefs.current[callId];
    if (audio && duration[callId]) {
      const newTime = (value / 100) * duration[callId];
      audio.currentTime = newTime;
      setCurrentTime((prev) => ({ ...prev, [callId]: newTime }));
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Search Bar */}
      <div className="border border-gray-300 rounded-lg flex items-center gap-3 h-12 px-4 mb-4 bg-white shadow-sm">
        <img
          src={icons.searchIcon}
          alt="Search"
          className="w-5 h-5 opacity-60"
        />
        <input
          onChange={(e) => setSearchQuery(e.target.value)}
          type="text"
          className="w-full h-full focus:outline-none text-gray-700 placeholder-gray-400"
          placeholder="Search by customer/lead name..."
        />
      </div>

      {/* Tab Navigation */}
      <div className="flex justify-around border-b border-gray-200 pb-2 mb-4 bg-white">
        {["all", "INCOMING", "OUTGOING", "MISSED"].map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 text-sm font-medium transition-all duration-200 ${
              selectedTab === tab
                ? "text-customGreen font-bold border-b-2 border-customGreen"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab === "all"
              ? "All Calls"
              : tab === "INCOMING"
              ? "Incoming"
              : tab === "OUTGOING"
              ? "Outgoing"
              : tab ==="MISSED" 
              ? "Missed" 
              : "RNR Calls"
              }
          </button>
        ))}
      </div>

      {/* Call Log List */}
      <div className=" customScrolbar overflow-y-auto h-64 ">
        {filteredCalls?.length === 0 ? (
          <div className="text-center flex flex-col items-center justify-center mt-20">
            <img
              src={icons.noCallLog}
              className="w-32 mb-4 opacity-60"
              alt="No calls"
            />
            <p className="text-gray-500 text-lg">No call logs available</p>
          </div>
        ) : (
          filteredCalls?.map((call, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl  shadow-sm hover:shadow-md transition-shadow duration-200 mb-4 p-4 bg-white"
            >
              <div className="flex justify-between">
                {/* Left Section */}
                <div className="flex-1">
                  <div
                    onClick={() => handleLeadInfo(call?.leadDocId)}
                    className="cursor-pointer hover:text-customGreen transition-colors duration-200"
                  >
                    <h1 className="text-xl font-semibold capitalize text-gray-800 mb-3">
                      {call?.leadName}
                    </h1>
                  </div>

                  {/* Call Info Grid */}
                  <div className="flex items-center gap-5">
                    <div className="flex items-center gap-2">
                      <img
                        src={
                          call?.callType === "INCOMING"
                            ? icons.incomingCall
                            : call.callType === "OUTGOING"
                            ? icons.outGoingCall
                            : call?.callType === "MISSED"
                            ? icons.missedCall
                            : ""
                        }
                        alt="Call type"
                        className="w-4 h-4"
                      />
                      <span className="text-sm text-gray-600">
                        {call?.callMadeTimestamp}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <img
                        src={icons.timerIcon}
                        alt="Duration"
                        className="w-4 h-4"
                      />
                      <span className="text-sm text-gray-600">
                        {call?.callDuration}
                      </span>
                      {call?.callType === "MISSED" && (
                        <span className="text-sm text-gray-600">(Rang)</span>
                      )}
                    </div>
                  </div>

                  {/* Audio Recording Section */}
                  {toggle && call?.callDuration !== "0h : 0m : 0s" && (
                    <div className="mt-3">
                      {activeRecordingId !== `${index}-${call?.leadDocId}` ? (
                        <button
                          onClick={() =>
                            toggleRecording(
                              `${index}-${call?.leadDocId}`,
                              call?.recordingUrl
                            )
                          }
                          className="flex items-center gap-2 bg-green-50 hover:bg-green-100 text-customGreen px-4 py-2 rounded-full transition-all duration-200 border border-green-200"
                        >
                          <FaMicrophoneLines className="text-lg" />
                          <span className="text-sm font-medium">
                            Play Recording
                          </span>
                        </button>
                      ) : (
                        <div className=" rounded-lg  ">
                          {/* Audio Controls */}
                          <div className="flex items-center gap-3 mb-3">
                            <button
                              onClick={() =>
                                togglePlayPause(`${index}-${call?.leadDocId}`)
                              }
                              className="text-customGreen  p-2 rounded-full transition-colors duration-200"
                            >
                              {playingStates[`${index}-${call?.leadDocId}`] ? (
                                <FaPause className="w-4 h-4" />
                              ) : (
                                <FaPlay className="w-4 h-4" />
                              )}
                            </button>

                            {/* <button
                            onClick={() => stopAudio(`${index}-${call?.leadDocId}`)}
                            className="bg-gray-500 hover:bg-gray-600 text-white p-2 rounded-full transition-colors duration-200"
                          >
                            <FaStop className="w-4 h-4" />
                          </button> */}

                            {/* <FaVolumeUp className="text-gray-500" /> */}

                            <div className="flex-1 flex items-center gap-2">
                              <span className="text-xs text-gray-500 min-w-[35px]">
                                {formatTime(
                                  currentTime[`${index}-${call?.leadDocId}`] ||
                                    0
                                )}
                              </span>
                              <input
                                type="range"
                                min="0"
                                max="100"
                                value={
                                  duration[`${index}-${call?.leadDocId}`]
                                    ? ((currentTime[
                                        `${index}-${call?.leadDocId}`
                                      ] || 0) /
                                        duration[
                                          `${index}-${call?.leadDocId}`
                                        ]) *
                                      100
                                    : 0
                                }
                                onChange={(e) =>
                                  handleSeek(
                                    `${index}-${call?.leadDocId}`,
                                    e.target.value
                                  )
                                }
                                className="custom-slider flex-1 w-full h-[6px] bg-green-200 rounded-lg appearance-none cursor-pointer"
                              />

                              <span className="text-xs text-gray-500 min-w-[35px]">
                                {formatTime(
                                  duration[`${index}-${call?.leadDocId}`] || 0
                                )}
                              </span>
                            </div>
                          </div>

                          {/* Hidden Audio Element */}
                          <audio
                            ref={(el) => {
                              if (el)
                                audioRefs.current[
                                  `${index}-${call?.leadDocId}`
                                ] = el;
                            }}
                            onTimeUpdate={() =>
                              handleTimeUpdate(`${index}-${call?.leadDocId}`)
                            }
                            onLoadedMetadata={() =>
                              handleLoadedMetadata(
                                `${index}-${call?.leadDocId}`
                              )
                            }
                            onEnded={() =>
                              handleEnded(`${index}-${call?.leadDocId}`)
                            }
                            className="hidden"
                          >
                            <source
                              src={call?.callRecordUrl}
                              type="audio/wav"
                            />
                            <source
                              src={call?.callRecordUrl}
                              type="audio/wav"
                            />
                            Your browser does not support the audio element.
                          </audio>

                          {/* <button
                          onClick={() => toggleRecording(`${index}-${call?.leadDocId}`)}
                          className="text-xs text-red-500 hover:text-red-700 underline transition-colors duration-200"
                        >
                          Hide Recording
                        </button> */}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Right Section - Status and Character */}
                <div className="flex items-center gap-6">
                  <div className="flex flex-col items-center gap-2">
                    <img
                      src={statusImage[call?.leadStatus]}
                      alt="Status"
                      className="w-8 h-8"
                    />
                    <h4 className="text-xs text-center text-gray-600 max-w-[80px]">
                      {call?.leadStatus}
                    </h4>
                  </div>
                  <div className="flex flex-col items-center gap-2">
                    <img
                      src={leadCharacter[call?.leadCharacter]}
                      alt="Character"
                      className="w-8 h-8"
                    />
                    <h4 className="text-xs text-center text-gray-600">
                      {call.leadCharacter}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CallLog;
